var render = function render(){var _vm=this,_c=_vm._self._c;return _c('update-assets')
}
var staticRenderFns = []

export { render, staticRenderFns }